import Container from './container'

export default function TransformandoDados() {
  return (
    <section className="bg-[#040116] text-white">
      <Container className="space-y-16 pt-12 pb-[69px] lg:pt-[86px] lg:pb-[133px]">
        <header className="font-inter-light text-2xl md:text-5xl text-center">
          Transformando dados em <br /> decisões estratégicas
        </header>
        <main className="flex flex-col md:flex-row justify-between gap-8 max-w-[260px] md:max-w-full mx-auto md:mx-0">
          <div className="space-y-0 md:space-y-2">
            <div className="h-full md:max-h-[285px]">
              <img
                src="../assets/data_mobile.png"
                alt=""
                className="block h-fit w-full md:hidden max-w-[260px]"
              />
              <img
                src="../assets/data.png"
                alt=""
                className="hidden md:block h-fit w-auto"
              />
            </div>
            <h3 className="text-center font-inter-light text-2xl -mt-4 md:mt-0">Data</h3>
          </div>
          <div className="space-y-0 md:space-y-2">
            <div className="h-full md:max-h-[285px]">
              <img
                src="../assets/analise_mobile.png"
                alt=""
                className="block h-fit w-full md:hidden max-w-[260px]"
              />
              <img
                src="../assets/analise.png"
                alt=""
                className="hidden md:block h-fit w-auto"
              />
            </div>
            <h3 className="text-center font-inter-light text-2xl -mt-4 md:mt-0">Análises</h3>
          </div>
          <div className="space-y-0 md:space-y-2">
            <div className="h-full md:max-h-[285px]">
              <img
                src="../assets/decisoes_mobile.png"
                alt=""
                className="block h-fit w-full md:hidden max-w-[260px]"
              />
              <img
                src="../assets/decisoes.png"
                alt=""
                className="hidden md:block h-fit w-auto"
              />
            </div>
            <h3 className="text-center font-inter-light text-2xl -mt-4 md:mt-0">Decisões</h3>
          </div>
        </main>
      </Container>
    </section>
  )
}
